var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.testPlace)?_c('div',{staticClass:"dashboard__actions"},[_c('router-link',{attrs:{"to":"/"}},[_c('i',{staticClass:"fas fa-arrow-left"}),_vm._v(" powrót\n  ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }